import { useCallback } from 'react';

import { Native } from '@givebacks/utils';
import { ClickableOptionsCard } from 'core/Components';
import { usePlatformService } from 'core/Hooks';
import { FAQ, LEGAL_URLS } from 'core/Utils';
import { Box, Container, Stack, Text, ThemeIcon } from 'ui';
import { useDisclosure } from 'ui/Hooks';
import { IconDelete } from 'ui/Icons';

import { DeleteAccountModal } from '../Profile/EditProfile/DeleteAccount';
import classes from './AccountPage.module.css';
import { AccountBalanceRewardsCard } from './components/AccountBalanceRewardsCard/AccountBalanceRewardsCard';
import { AccountPageHeader } from './components/AccountPageHeader/AccountPageHeader';
import { AccountPageShortcuts } from './components/AccountPageShortcuts/AccountPageShortcuts';
import { CardsOnFile } from './components/CardsOnFile';
import { ProfileActions } from './components/ProfileActions';
import { Settings } from './components/Settings/Settings';
import { SignOutRowAction } from './components/SignOut/SignOutRowAction';

const AccountPage = () => {
  const Platform = usePlatformService();
  const [isDeleteAccountModalOpen, deleteAccountModalHandler] = useDisclosure(false);

  const handleWebsiteClick = useCallback(
    (url: string) => {
      if (Platform.isNative) {
        Native.postURL(url);
      } else {
        window.open(url, '_blank', '');
      }
    },
    [Platform.isNative]
  );

  return (
    <Box>
      <AccountPageHeader />
      <Box className={classes.AccountPage}>
        <Container size="sm" px={{ base: '0px', sm: 'xs' }}>
          <Stack gap="xl">
            <AccountPageShortcuts />

            <AccountBalanceRewardsCard />

            <CardsOnFile />

            <ProfileActions />

            <Settings />

            <ClickableOptionsCard variant="gray">
              <ClickableOptionsCard.Row
                title="Help Center & Support"
                onClick={() => handleWebsiteClick(FAQ.HELP_CENTER_URL)}
              />
              <ClickableOptionsCard.Row
                groupProps={{ mod: { 'gb-pendo-feedback': true } }}
                title="Leave Feedback"
                onClick={() => void 0}
              />
              <ClickableOptionsCard.Row
                title="Legal"
                onClick={() => handleWebsiteClick(LEGAL_URLS.TERMS_OF_SERVICE_URL)}
              />
            </ClickableOptionsCard>

            <SignOutRowAction />
            <ClickableOptionsCard variant="danger">
              <ClickableOptionsCard.Row
                leftSection={
                  <ThemeIcon variant="transparent" c="cerise.7">
                    <IconDelete />
                  </ThemeIcon>
                }
                title={
                  <Text c="cerise.7" fw={500} fz="sm">
                    Delete My Givebacks Account
                  </Text>
                }
                onClick={deleteAccountModalHandler.open}
                rightSection={<></>}
              />
            </ClickableOptionsCard>
          </Stack>
        </Container>
      </Box>
      <DeleteAccountModal
        opened={isDeleteAccountModalOpen}
        onClose={deleteAccountModalHandler.close}
      />
    </Box>
  );
};

export { AccountPage };
